//Core
import React from "react"

//Іtyles
import style from "./style.module.scss"

const Dot = ({ item, click, active }) => (
  <div
    className={[style.dot, active ? style.active : null].join(" ")}
    onClick={() => click(item)}
  />
)

const Dots = ({ activeItem, handleOnClick }) => {
  return (
    <div className={style.dots_wraper}>
      {new Array(5).fill(0).map((el, index) => (
        <Dot
          item={index}
          key={index}
          click={handleOnClick}
          active={activeItem === index}
        />
      ))}
    </div>
  )
}

export default Dots
